(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1215,5467,4006],{

/***/ 3156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _src_components_Shared_BreadCrumbs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5467);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6896);
/* harmony import */ var _styles_partners_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3629);
/* harmony import */ var _styles_partners_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_partners_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _src_components_Home_Countries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5424);
/* harmony import */ var _src_components_Shared_Next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6543);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);










var recruitmentCountriesSchema = {
  "@context": "https://schema.org",
  "@graph": [{
    "@type": "BreadcrumbList",
    "@id": "https://alnjoom.sa/recruitmentCountries/#breadcrumb",
    itemListElement: [{
      "@type": "ListItem",
      position: 1,
      name: "الرئيسية",
      item: "https://alnjoom.sa/"
    }, {
      "@type": "ListItem",
      position: 2,
      name: "دول الاستقدام",
      item: "https://alnjoom.sa/recruitmentCountries/"
    }]
  }, {
    "@type": "CollectionPage",
    "@id": "https://alnjoom.sa/recruitmentCountries/#webpage",
    url: "https://alnjoom.sa/recruitmentCountries/",
    name: "دول الاستقدام - مكتب النجوم المميزة للاستقدام",
    description: "تصفح جميع دول الاستقدام المعتمدة لدى مكتب النجوم المميزة للاستقدام: بنغلاديش، أثيوبيا، الفلبين، باكستان، كينيا، وبوروندي، واختر العاملة المنزلية المناسبة لك.",
    inLanguage: "ar",
    isPartOf: {
      "@id": "https://alnjoom.sa/#website"
    },
    breadcrumb: {
      "@id": "https://alnjoom.sa/recruitmentCountries/#breadcrumb"
    },
    mainEntity: {
      "@id": "https://alnjoom.sa/recruitmentCountries/#itemlist"
    }
  }, {
    "@type": "ItemList",
    "@id": "https://alnjoom.sa/recruitmentCountries/#itemlist",
    name: "دول الاستقدام المتاحة",
    numberOfItems: 6,
    itemListElement: [{
      "@type": "ListItem",
      position: 1,
      url: "https://alnjoom.sa/recruitmentCountries/FVOfWFcbM/",
      item: {
        "@type": "Service",
        name: "استقدام عاملة منزلية من بنغلاديش",
        url: "https://alnjoom.sa/recruitmentCountries/FVOfWFcbM/",
        serviceType: "استقدام عمالة منزلية",
        areaServed: {
          "@type": "Country",
          name: "المملكة العربية السعودية"
        },
        provider: {
          "@id": "https://alnjoom.sa/#organization"
        }
      }
    }, {
      "@type": "ListItem",
      position: 2,
      url: "https://alnjoom.sa/recruitmentCountries/7qxEJng5g/",
      item: {
        "@type": "Service",
        name: "استقدام عاملة منزلية من أثيوبيا",
        url: "https://alnjoom.sa/recruitmentCountries/7qxEJng5g/",
        serviceType: "استقدام عمالة منزلية",
        areaServed: {
          "@type": "Country",
          name: "المملكة العربية السعودية"
        },
        provider: {
          "@id": "https://alnjoom.sa/#organization"
        }
      }
    }, {
      "@type": "ListItem",
      position: 3,
      url: "https://alnjoom.sa/recruitmentCountries/i7beLSowJ/",
      item: {
        "@type": "Service",
        name: "استقدام عاملة منزلية من الفلبين",
        url: "https://alnjoom.sa/recruitmentCountries/i7beLSowJ/",
        serviceType: "استقدام عمالة منزلية",
        areaServed: {
          "@type": "Country",
          name: "المملكة العربية السعودية"
        },
        provider: {
          "@id": "https://alnjoom.sa/#organization"
        }
      }
    }, {
      "@type": "ListItem",
      position: 4,
      url: "https://alnjoom.sa/recruitmentCountries/cAqU9YF2n/",
      item: {
        "@type": "Service",
        name: "استقدام عاملة منزلية من باكستان",
        url: "https://alnjoom.sa/recruitmentCountries/cAqU9YF2n/",
        serviceType: "استقدام عمالة منزلية",
        areaServed: {
          "@type": "Country",
          name: "المملكة العربية السعودية"
        },
        provider: {
          "@id": "https://alnjoom.sa/#organization"
        }
      }
    }, {
      "@type": "ListItem",
      position: 5,
      url: "https://alnjoom.sa/recruitmentCountries/4CfY7t_MR/",
      item: {
        "@type": "Service",
        name: "استقدام عاملة منزلية من كينيا",
        url: "https://alnjoom.sa/recruitmentCountries/4CfY7t_MR/",
        serviceType: "استقدام عمالة منزلية",
        areaServed: {
          "@type": "Country",
          name: "المملكة العربية السعودية"
        },
        provider: {
          "@id": "https://alnjoom.sa/#organization"
        }
      }
    }, {
      "@type": "ListItem",
      position: 6,
      url: "https://alnjoom.sa/recruitmentCountries/oqGSCVMrm/",
      item: {
        "@type": "Service",
        name: "استقدام عاملة منزلية من بوروندي",
        url: "https://alnjoom.sa/recruitmentCountries/oqGSCVMrm/",
        serviceType: "استقدام عمالة منزلية",
        areaServed: {
          "@type": "Country",
          name: "المملكة العربية السعودية"
        },
        provider: {
          "@id": "https://alnjoom.sa/#organization"
        }
      }
    }]
  }]
};

var Page = function Page(_ref) {
  var _seoData$title, _seoData$title2, _seoData$description, _seoData$keywords;

  var countriesData = _ref.countriesData,
      personnelsData = _ref.personnelsData,
      seoData = _ref.seoData;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(),
      locale = _useIntl.locale,
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(recruitmentCountriesSchema)
        }
      })
    }), (seoData === null || seoData === void 0 ? void 0 : (_seoData$title = seoData.title) === null || _seoData$title === void 0 ? void 0 : _seoData$title[locale]) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_src_components_Shared_Next_seo__WEBPACK_IMPORTED_MODULE_4__["default"], {
      title: seoData === null || seoData === void 0 ? void 0 : (_seoData$title2 = seoData.title) === null || _seoData$title2 === void 0 ? void 0 : _seoData$title2[locale],
      description: seoData === null || seoData === void 0 ? void 0 : (_seoData$description = seoData.description) === null || _seoData$description === void 0 ? void 0 : _seoData$description[locale],
      keywords: seoData === null || seoData === void 0 ? void 0 : (_seoData$keywords = seoData.keywords) === null || _seoData$keywords === void 0 ? void 0 : _seoData$keywords[locale]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_src_components_Shared_BreadCrumbs__WEBPACK_IMPORTED_MODULE_1__["default"], {
      heading: formatMessage({
        id: "recruitmentCountries"
      }),
      description: "".concat(formatMessage({
        id: "main"
      }), " / ").concat(formatMessage({
        id: "recruitmentCountries"
      })),
      background: countriesData === null || countriesData === void 0 ? void 0 : countriesData.breadCurmbImage
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: (_styles_partners_module_scss__WEBPACK_IMPORTED_MODULE_7___default().aboutPage),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_src_components_Home_Countries__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        data: countriesData,
        personnel: personnelsData,
        page: "partners"
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);

/***/ }),

/***/ 5424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Countries; }
/* harmony export */ });
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1555);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2615);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _handlers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9400);
/* harmony import */ var _helpers_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7819);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);









function Countries(_ref) {
  var _data$items;

  var data = _ref.data,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? "" : _ref$page;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      locale = _useRouter.locale;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().partners), " wrapper ").concat(page, " w-100"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      className: "w-100 m-0",
      children: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(function (item, index) {
        var _item$name;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          xxl: 2,
          lg: 3,
          md: 4,
          sm: 6,
          xs: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: "item",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: "/recruitmentCountries/".concat((0,_helpers_functions__WEBPACK_IMPORTED_MODULE_3__/* .getId */ .zv)(item)),
              legacyBehavior: true,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {})
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
              src: (0,_handlers__WEBPACK_IMPORTED_MODULE_2__/* .handleImage */ .M)(item === null || item === void 0 ? void 0 : item.image),
              height: 71,
              width: 71,
              alt: ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name[locale]
            })]
          })
        }, "country" + index);
      })
    })
  });
}

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);







var BreadCrumb = function BreadCrumb(_ref) {
  var _heading$locale, _description$locale;

  var heading = _ref.heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "" : _ref$description;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      pathname = _useRouter.pathname;

  var shouldHidePath = pathname.startsWith("/blogs/") && pathname !== "/blogs";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "breads wrapper",
    style: {
      backgroundColor: "rgb(112 96 166 / 100%)"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "inner",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
          className: "unique-bold h3",
          children: (_heading$locale = heading === null || heading === void 0 ? void 0 : heading[locale]) !== null && _heading$locale !== void 0 ? _heading$locale : heading
        }), ((description === null || description === void 0 ? void 0 : description[locale]) || (description === null || description === void 0 ? void 0 : description.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
          children: !shouldHidePath && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            children: (_description$locale = description === null || description === void 0 ? void 0 : description[locale]) !== null && _description$locale !== void 0 ? _description$locale : description
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 6543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var Seo = function Seo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$noindex = _ref.noindex,
      noindex = _ref$noindex === void 0 ? false : _ref$noindex;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      asPath = _useRouter.asPath,
      locale = _useRouter.locale;

  var _buildSeoAlternates = (0,_src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__/* .buildSeoAlternates */ .Rl)(asPath, locale),
      canonical = _buildSeoAlternates.canonical,
      languageAlternates = _buildSeoAlternates.languageAlternates;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
    title: title,
    description: description,
    defaultTitle: title,
    noindex: noindex,
    nofollow: noindex,
    canonical: canonical,
    languageAlternates: languageAlternates,
    additionalMetaTags: [{
      name: "keywords",
      content: keywords
    }]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Seo);

/***/ }),

/***/ 9400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ handleImage; }
});

;// CONCATENATED MODULE: ./src/assets/images/placeholder.jpg
/* harmony default export */ var placeholder = ({"src":"/_next/static/media/placeholder.75cf2fc2.jpg","height":319,"width":474,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAsgP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/9oACAEBAAE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/handlers/index.js

var handleImage = function handleImage(image) {
  var _ref;

  if ((_ref = "".concat(image)) !== null && _ref !== void 0 && _ref.includes("http")) return image;

  if (image) {
    if (!image.startsWith("/")) image = "/".concat(image);
    return "".concat("https://alnojoom.ejjadh.info/").concat(image);
  }

  return image || (placeholder === null || placeholder === void 0 ? void 0 : placeholder.src);
};

/***/ }),

/***/ 7819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ handleImageLink; },
/* harmony export */   "SI": function() { return /* binding */ htmlToExcerpt; },
/* harmony export */   "zv": function() { return /* binding */ getId; }
/* harmony export */ });
/* unused harmony exports mapBlogForListing, checkRedirect */
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);



var getId = function getId(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj._id) || (obj === null || obj === void 0 ? void 0 : obj.id) || "".concat(obj);
}; // يبني مُقتطف نصي قصير من HTML كامل (يحذف الصور base64 والوسوم) لتفادي تضخيم حجم الصفحة

var htmlToExcerpt = function htmlToExcerpt(html) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  if (!html) return "";
  var withoutImages = String(html).replace(/<img[^>]*>/gi, "");
  var text = withoutImages.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return text.length > maxLength ? "".concat(text.slice(0, maxLength).trim(), "\u2026") : text;
}; // يحوّل قيمة مترجمة (ar/en) تحتوي HTML كامل إلى نفس الشكل لكن بمقتطف نصي قصير

var localizedExcerpt = function localizedExcerpt(localized, maxLength) {
  if (!localized || typeof localized !== "object") return localized;
  return Object.fromEntries(Object.entries(localized).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        locale = _ref2[0],
        html = _ref2[1];

    return [locale, htmlToExcerpt(html, maxLength)];
  }));
}; // يبني نسخة خفيفة من كائن المدونة لصفحات القوائم، بدون وصف HTML الكامل
// (الذي قد يحتوي صورًا مرفوعة كـ base64 ويُضاعف حجم الصفحة عند تسلسله ضمن __NEXT_DATA__)


var mapBlogForListing = function mapBlogForListing(blog) {
  var _blog$category, _blog$category2, _blog$category3;

  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return {
    id: (blog === null || blog === void 0 ? void 0 : blog.id) || (blog === null || blog === void 0 ? void 0 : blog._id) || null,
    title: blog === null || blog === void 0 ? void 0 : blog.title,
    image: blog === null || blog === void 0 ? void 0 : blog.image,
    category: blog !== null && blog !== void 0 && blog.category ? {
      id: (blog === null || blog === void 0 ? void 0 : (_blog$category = blog.category) === null || _blog$category === void 0 ? void 0 : _blog$category.id) || (blog === null || blog === void 0 ? void 0 : (_blog$category2 = blog.category) === null || _blog$category2 === void 0 ? void 0 : _blog$category2._id) || null,
      title: (blog === null || blog === void 0 ? void 0 : (_blog$category3 = blog.category) === null || _blog$category3 === void 0 ? void 0 : _blog$category3.title) || null
    } : null,
    createdAt: blog === null || blog === void 0 ? void 0 : blog.createdAt,
    description: localizedExcerpt(blog === null || blog === void 0 ? void 0 : blog.description, maxLength)
  };
};
var handleImageLink = function handleImageLink(image) {
  if (image !== null && image !== void 0 && image.includes("http")) {
    return image;
  } else {
    return "".concat("https://alnojoom.ejjadh.info/", "/").concat(image);
  }
}; // ضع هذا الكود داخل نفس ملف الصفحة

var REDIRECTS_ENDPOINT = "https://alnojoom.ejjadh.info/api/seoRedirects"; // نظّف المسار: فك التشفير + إزالة ?query + إزالة / آخر المسار

function cleanPath() {
  var resolvedUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  try {
    var noQuery = String(resolvedUrl).split("?")[0] || "/";
    var decoded = decodeURI(noQuery);
    return decoded.length > 1 && decoded.endsWith("/") ? decoded.slice(0, -1) : decoded;
  } catch (_unused) {
    var _noQuery = String(resolvedUrl).split("?")[0] || "/";

    return _noQuery.length > 1 && _noQuery.endsWith("/") ? _noQuery.slice(0, -1) : _noQuery;
  }
} // ابنِ Destination مطلق بدون أي Query Params


function toAbsoluteNoQuery(destRaw, req) {
  try {
    if (/^https?:\/\//i.test(destRaw)) {
      var u = new URL(destRaw);
      u.search = "";
      return u.toString();
    }

    var protocol = (req.headers["x-forwarded-proto"] || "").split(",")[0] || (req.socket && req.socket.encrypted ? "https" : "http");
    var host = req.headers.host;
    var path = destRaw.startsWith("/") ? destRaw : "/".concat(destRaw);
    return "".concat(protocol, "://").concat(host).concat(path);
  } catch (_unused2) {
    return String(destRaw).split("?")[0];
  }
}

function checkRedirect(_x, _x2) {
  return _checkRedirect.apply(this, arguments);
}

function _checkRedirect() {
  _checkRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolvedUrl, req) {
    var path, res, json, redirects, hit, permanent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = cleanPath(resolvedUrl);
            _context.prev = 1;
            _context.next = 4;
            return fetch(REDIRECTS_ENDPOINT, {
              headers: {
                Accept: "application/json"
              }
            });

          case 4:
            res = _context.sent;

            if (res.ok) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", null);

          case 7:
            _context.next = 9;
            return res.json();

          case 9:
            json = _context.sent;
            redirects = json && json.data && json.data.seoRedirects || [];
            hit = redirects.find(function (r) {
              return (r === null || r === void 0 ? void 0 : r.source) && (r === null || r === void 0 ? void 0 : r.destination) && cleanPath(r.source) === path;
            });

            if (hit) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", null);

          case 14:
            permanent = String(hit.redirectCode) === "301" || String(hit.redirectCode) === "308";
            return _context.abrupt("return", {
              destination: toAbsoluteNoQuery(String(hit.destination).trim(), req),
              permanent: permanent
            });

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", null);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));
  return _checkRedirect.apply(this, arguments);
}

/***/ }),

/***/ 540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rl": function() { return /* binding */ buildSeoAlternates; }
/* harmony export */ });
/* unused harmony exports SITE_URL, DEFAULT_LOCALE, localizedUrl */
// ====== إعدادات الـ SEO المشتركة ======
var SITE_URL = "https://alnjoom.sa";
var DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية
// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash

var normalizePath = function normalizePath() {
  var asPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = "/".concat(path); // مطابقة لإعداد trailingSlash: true في next.config.js

  if (path !== "/" && !path.endsWith("/")) path = "".concat(path, "/");
  return path;
}; // يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)


var localizedUrl = function localizedUrl(asPath, locale) {
  var path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"

  if (locale === DEFAULT_LOCALE) return "".concat(SITE_URL).concat(path);
  return path === "/" ? "".concat(SITE_URL, "/").concat(locale, "/") : "".concat(SITE_URL, "/").concat(locale).concat(path);
}; // يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية

var buildSeoAlternates = function buildSeoAlternates(asPath) {
  var currentLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  return {
    canonical: localizedUrl(asPath, currentLocale),
    languageAlternates: [{
      hrefLang: "ar",
      href: localizedUrl(asPath, "ar")
    }, {
      hrefLang: "en",
      href: localizedUrl(asPath, "en")
    }, {
      hrefLang: "x-default",
      href: localizedUrl(asPath, DEFAULT_LOCALE)
    }]
  };
};

/***/ }),

/***/ 1399:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitmentCountries",
      function () {
        return __webpack_require__(3156);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"partners":"Countries_partners__zKNov","gradient_in":"Countries_gradient_in__iWN_E","gradient_out":"Countries_gradient_out__e5rJQ","gradient_opacity_out":"Countries_gradient_opacity_out__pKqTE","gradient_opacity_in":"Countries_gradient_opacity_in__TWQ6e"};

/***/ }),

/***/ 3629:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aboutPage":"partners_aboutPage__Vksra","gradient_in":"partners_gradient_in__BMvhe","gradient_out":"partners_gradient_out__Ie3gM","gradient_opacity_out":"partners_gradient_opacity_out__fxI3D","gradient_opacity_in":"partners_gradient_opacity_in__6pQ_8"};

/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useCol */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,2143,1664,9774,2888,179], function() { return __webpack_exec__(1399); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);